<template>
    <ActionPanel class="EditablePanel" :title="title">
        <template v-slot:actions v-if="emptyAddress==false">
            <EditButton
                :editable="editable"
                @click="$emit('edit')"
                :editLabel="editLabel"
                :cancelLabel="cancelLabel"
                :class="{'disabled':disabled===true}"
                v-if="loading===false"
                />
        </template>
        <form @submit.prevent="$emit('save')">
            <div class="content">
                <slot></slot>
            </div>
            <CircleLoadingButton :isLoading="isLoading">
              <SmallButton
                  v-if="emptyAddress || editable"
                  type="submit"
                  class="save-button"
                  border-color="primary"
              >
                Zapisz
              </SmallButton>
            </CircleLoadingButton>
        </form>
    </ActionPanel>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
import SmallButton from '@/components/input/SmallButton.vue';
import EditButton from '@/components/input/EditButton.vue';
import ActionPanel from './ActionPanel.vue';
import CircleLoadingButton from '@/components/input/CircleLoadingButton'

    library.add(faPen, faTimes);

    export default {
        name: 'EditablePanel',
        components: {
          CircleLoadingButton,
            ActionPanel,
            SmallButton,
            EditButton,
        },
        props: {
            title: {
                type: String,
                required: true,
            },
            editLabel: {
                type: String,
                default: 'Edytuj',
            },
            cancelLabel: {
                type: String,
                default: 'Anuluj',
            },
            editable: {
                type: Boolean,
                required: true,
            },
            emptyAddress: {
                type: Boolean,
                default: false,
                required: false,
            },
            disabled: {
                type: Boolean,
                required: false,
            },
            loading: {
                type: Boolean,
                required: false,
            },
            isLoading: {
              type: Boolean,
              default: false,
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/globals.scss";

    .content {
        margin-bottom: 20px;
    }

    .save-button {
        width: 100%;
    }

    .disabled{
        cursor: default;
    }
</style>
